module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Mis consultas":"Mis consultas","Por pedidos":"Por pedidos","Por artículos":"Por artículos","Por albarán":"Por albarán","Por proyecto":"Por proyecto"},"en":{"Búsqueda":"Search"},"ca":{"Mis consultas":"Les meves consultes","Por pedidos":"Per comandes","Por artículos":"Per articles","Por albarán":"Per albarà","Por proyecto":"Per projecte"}}')
  delete Component.options._Ctor
}
